<template>
    <v-card>
        <v-card-title>
            Users filter
        </v-card-title>
        <v-card-text>
            <v-form ref="userIdForm" v-model="userIdValid" lazy-validation>
                <v-row>
                    <v-col cols="4" style="height: 45px;">
                        <v-text-field v-model="userId" label="User ID" :rules="userIdRules" required clearable outlined dense/>
                    </v-col>
                    <v-col cols="2" style="height: 45px;">
                        <v-btn class="mr-4" @click="submitUserId">submit</v-btn>
                    </v-col>
                </v-row>
            </v-form>
            <br><hr>
            <v-row>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="userName" label="User name" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-select v-model="payer" :items="['Yes', 'No']" label="Payer" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" md="2" style="height: 45px;">
                    <!--                        <v-autocomplete v-model="platform" :items="['Android', 'iOS', 'Steam']" label="Platforms" multiple clearable outlined dense small-chips deletable-chips/>-->
                    <v-select v-model="platform" :items="$store.getters.platforms" label="Platform" clearable outlined dense small-chips/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
<!--                    <v-text-field v-model="appVersion" label="App version" clearable outlined dense/>-->
                    <v-combobox v-model="appVersion" :items="$store.getters.versions" label="App version" clearable outlined dense small-chips/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="coins" label="Coins" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="energy" label="Energy" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="season" label="Season" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="level" label="Level" clearable outlined dense/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb1" label="Bomb1" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb2" label="Bomb2" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb3" label="Bomb3" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb4" label="Radar" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb6" label="Horizontal" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 50px;">
                    <v-text-field v-model="bomb7" label="Vertical" clearable outlined dense/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submit" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <br><hr>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Coins</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="coinsStart" label="start" hint="" persistent-hint clearable outlined dense />
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="coinsEnd" label="end" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitInt(coinsStart, coinsEnd, 'coins')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Energy</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="energyStart" label="start" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="energyEnd" label="end" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitInt(energyStart, energyEnd, 'energy')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Level</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="levelStart" label="start" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="levelEnd" label="end" hint="" persistent-hint clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitInt(levelStart, levelEnd, 'level')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Season</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="seasonStart" label="start" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="seasonEnd" label="end" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitInt(seasonStart, seasonEnd, 'season')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Bomb1</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb1Start" label="start" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb1End" label="end" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitInt(bomb1Start, bomb1End, 'bomb1')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Bomb2</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb2Start" label="start" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb2End" label="end" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitInt(bomb2Start, bomb2End, 'bomb2')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Bomb3</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb3Start" label="start" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb3End" label="end" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitInt(bomb3Start, bomb3End, 'bomb3')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Radar</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb4Start" label="start" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb4End" label="end" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitInt(bomb4Start, bomb4End, 'bomb4')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Horizontal</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb6Start" label="start" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb6End" label="end" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitInt(bomb6Start, bomb6End, 'bomb6')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Vertical</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb7Start" label="start" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-text-field v-model="bomb7End" label="end" clearable outlined dense/>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitInt(bomb7Start, bomb7End, 'bomb7')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Created</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-menu ref="menu1" v-model="dateCreatedStartMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="computedDateCreated" label="Start" persistent-hint prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" clearable outlined dense/>
                        </template>
                        <v-date-picker v-model="dateCreatedStart" no-title @input="dateCreatedStartMenu = false"/>
                    </v-menu>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-menu ref="menu1" v-model="dateCreatedEndMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="computedDateUpdated" label="End" persistent-hint prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" clearable outlined dense/>
                        </template>
                        <v-date-picker v-model="dateCreatedEnd" no-title @input="dateCreatedEndMenu = false"/>
                    </v-menu>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitTimestamp(dateCreatedStart, dateCreatedEnd, 'created')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" style="height: 45px;">
                    <v-subheader>Updated</v-subheader>
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-menu ref="menu1" v-model="dateUpdatedStartMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="computedDateFormattedStart" label="Start" persistent-hint prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" clearable outlined dense/>
                        </template>
                        <v-date-picker v-model="dateUpdatedStart" no-title @input="dateUpdatedStartMenu = false"/>
                    </v-menu>
                </v-col>
                <v-col cols="2" class="d-flex align-center">
                    <!--                        <v-card flat height="50" width="20"><strong>-</strong></v-card>-->
                    <v-menu v-model="dateUpdatedEndMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="computedDateFormattedEnd" label="End" persistent-hint prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" clearable outlined dense/>
                        </template>
                        <v-date-picker v-model="dateUpdatedEnd" no-title @input="dateUpdatedEndMenu = false"/>
                    </v-menu>
                    <!--                        <p>Date in ISO format: <strong>{{ date }}</strong></p>-->
                </v-col>
                <v-col cols="2" style="height: 45px;">
                    <v-btn class="mr-4" @click="submitTimestamp(dateUpdatedStart, dateUpdatedEnd, 'updated')" align="left">submit</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="12">
                    <v-data-table
                            dense
                            :headers="headers"
                            :items="items"
                            :items-per-page="20"
                            :footer-props="{'items-per-page-options': [10, 20, 50, 100, -1]}"
                            :search="search"
                            style="white-space: nowrap"
                    >
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Users</v-toolbar-title>
                                <v-divider class="mx-2" inset vertical/>
                                <!--                    <v-btn @click="createItem" class="ma-2" color="primary">-->
                                <!--                        New User-->
                                <!--                    </v-btn>-->
                                <v-spacer/>
                                <v-text-field
                                        append-icon="search"
                                        hide-details
                                        label="Search"
                                        single-line
                                        v-model.trim="search"
                                />
                            </v-toolbar>
                        </template>
                        <!--            <template v-slot:item.actions="{item}">-->
                        <!--                <v-icon @click="updateItem(item)" class="mr-2" small>-->
                        <!--                    mdi-pencil-->
                        <!--                </v-icon>-->
                        <!--                <v-icon @click="copyItem(item)" class="mr-2" small>-->
                        <!--                    mdi-content-copy-->
                        <!--                </v-icon>-->
                        <!--            </template>-->
                        <!--            <template v-slot:item.level="{item}">-->
                        <!--                <div align="center">-->
                        <!--                    <v-label>{{ item.minLevel }} - {{ item.maxLevel }}</v-label>-->
                        <!--                </div>-->
                        <!--            </template>-->
                        <!--            <template v-slot:item.enabled="{item}">-->
                        <!--                <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>-->
                        <!--            </template>-->
                        <!--            <template v-slot:no-results>-->
                        <!--                <v-alert :value="true" color="blue-grey" dense>-->
                        <!--                    Your search for "{{ search }}" found no results.-->
                        <!--                </v-alert>-->
                        <!--            </template>-->
                    </v-data-table>
                </v-col>
            </v-row>

        </v-card-text>
<!--        <v-product-dialog ref="product-dialog"/>-->
    </v-card>
</template>

<script>
    //import VueTypes from "vue-types";
    //import VProductDialog from "./VProductDialog";
    //import {StoreHelper} from "../../utils/StoreHelper";
    //import {User} from "./User";
    import database from "../store/database";
    //import ViewRules from "../../utils/ViewRules";
    import dayJS from 'dayjs';
    import relativeTime from 'dayjs/plugin/relativeTime';
    import * as firebase from 'firebase/app'

    dayJS.extend(relativeTime);

    export default {
        name: "VUsersPage",
        //components: {VProductDialog},
        data: (vm) => ({
            search: "",
            headers: [
                { text: "Id", value: "id"},
                { text: "Name", value: "name"},
                { text: "Payer", value: "payer"},
                { text: "Platform", value: "platform"},
                { text: "Coins", value: "coins"},
                { text: "Energy", value: "energy"},
                { text: "Season", value: "season"},
                { text: "Level", value: "level"},
                { text: "Bomb1", value: "bomb1"},
                { text: "Bomb2", value: "bomb2"},
                { text: "Bomb3", value: "bomb3"},
                { text: "Radar", value: "bomb4"},
                { text: "Horizontal", value: "bomb6"},
                { text: "Vertical", value: "bomb7"},
                { text: "App version", value: "version"},
                { text: "Updated", value: "updated"},
                { text: "Created", value: "created"},
            ],
            items: [],

            userId: '',
            userName: '',
            payer: '',
            platform:'',
            appVersion: '',
            dateCreatedStart:'',
            dateCreatedStartFormatted: '',
            dateCreatedStartMenu: false,
            dateCreatedEnd: '',
            dateCreatedEndFormatted: '',
            dateCreatedEndMenu: false,
            bomb1: '',
            bomb2: '',
            bomb3: '',
            bomb4: '',
            bomb6: '',
            bomb7: '',
            coins: '',
            energy: '',
            season: '',
            level: '',

            coinsStart:'',
            coinsEnd:'',
            energyStart:'',
            energyEnd:'',
            levelStart:'',
            levelEnd:'',
            ratingStart:'',
            ratingEnd:'',
            seasonStart:'',
            seasonEnd:'',
            //starsStart:'',
            //starsEnd:'',
            bomb1Start: '',
            bomb1End: '',
            bomb2Start: '',
            bomb2End: '',
            bomb3Start: '',
            bomb3End: '',
            bomb4Start: '',
            bomb4End: '',
            bomb6Start: '',
            bomb6End: '',
            bomb7Start: '',
            bomb7End: '',

            dateUpdatedStart: '',//new Date().toISOString().substr(0, 10),
            dateUpdatedEnd: '',//new Date().toISOString().substr(0, 10),
            dateUpdatedFormattedStart: '',//vm.formatDate(new Date().toISOString().substr(0, 10)),
            dateUpdatedFormattedEnd: '',//vm.formatDate(new Date().toISOString().substr(0, 10)),
            dateUpdatedStartMenu: false,
            dateUpdatedEndMenu: false,

            userIdValid: true,
            userIdRules: [
                v => !!v || 'User ID is required',
                v => (v == null || v.length > 27) || 'User ID must be more than 27 characters',
            ],
        }),
        computed: {
            computedDateCreated: {
                get: function () {
                    return this.formatDate(this.dateCreatedStart)
                },
                set: function (newValue) {
                    this.dateCreatedStart = newValue
                }
            },
            computedDateUpdated: {
                get: function () {
                    return this.formatDate(this.dateCreatedEnd)
                },
                set: function (newValue) {
                    this.dateCreatedEnd = newValue
                }
            },
            computedDateFormattedStart: {
                get: function () {
                    return this.formatDate(this.dateUpdatedStart)
                },
                set: function (newValue) {
                    this.dateUpdatedStart = newValue
                }
            },
            computedDateFormattedEnd : {
                get: function () {
                    return this.formatDate(this.dateUpdatedEnd)
                },
                set: function (newValue) {
                    this.dateUpdatedEnd = newValue
                }
            },
            pageHeight: {
                get: function () {
                    return document.body.scrollHeight
                }
            }
        },
        watch: {
            dateCreated (val) {
                this.dateCreatedStartFormatted = this.formatDate(this.dateCreatedStart)
            },
            dateUpdated (val) {
                this.dateCreatedEndFormatted = this.formatDate(this.dateCreatedEnd)
            },
            dateUpdatedStart (val) {
                this.dateUpdatedFormattedStart = this.formatDate(this.dateUpdatedStart)
            },
            dateUpdatedEnd (val) {
                this.dateUpdatedFormattedEnd = this.formatDate(this.dateUpdatedEnd)
            },
        },
        methods: {
            submitUserId(){
                this.$refs.userIdForm.validate()
                if(this.userId){
                    database.collection("users").doc(this.userId).get()
                        .then((doc) => {
                            this.items = []
                            if(doc.exists){
                                this.setItem(doc)
                                this.$vuetify.goTo(this.pageHeight)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        });
                }
                // else{
                //     database.collection("users").get()
                //         .then((querySnapshot) => {
                //             this.setItems(querySnapshot);
                //             this.$vuetify.goTo(this.pageHeight)
                //         })
                //         .catch((error) => {
                //             console.log(error)
                //         });
                // }
            },
            submit () {
                let collection = database.collection("users")
                if( this.userName ){
                    collection = collection.where("name", "==", this.userName)
                }
                if( this.payer ){
                    collection = collection.where("payer", "==", this.payer === 'Yes')
                }
                if( this.platform ){
                    collection = collection.where("platform", "==", this.platform.toLowerCase())
                }
                if( this.appVersion ){
                    collection = collection.where("version", "==", this.appVersion)
                }
                if( this.bomb1 ){
                    collection = collection.where("bomb1", "==", parseInt(this.bomb1))
                }
                if( this.bomb2 ){
                    collection = collection.where("bomb2", "==", parseInt(this.bomb2))
                }
                if( this.bomb3 ){
                    collection = collection.where("bomb3", "==", parseInt(this.bomb3))
                }
                if( this.bomb4 ){
                    collection = collection.where("bomb4", "==", parseInt(this.bomb4))
                }
                if( this.bomb6 ){
                    collection = collection.where("bomb6", "==", parseInt(this.bomb6))
                }
                if( this.bomb7 ){
                    collection = collection.where("bomb7", "==", parseInt(this.bomb7))
                }
                if( this.coins ){
                    collection = collection.where("coins", "==", parseInt(this.coins))
                }
                if( this.energy ){
                    collection = collection.where("energy", "==", parseInt(this.energy))
                }
                if( this.season ){
                    collection = collection.where("season", "==", parseInt(this.season))
                }
                if( this.level ){
                    collection = collection.where("level", "==", parseInt(this.level))
                }

                this.getCollection(collection)
            },
            submitInt(ratingStart, ratingEnd, fieldPath){
                let collection = database.collection("users")
                if( ratingStart ){
                    collection = collection.where(fieldPath, ">=", parseInt(ratingStart) )
                }
                if( ratingEnd ) {
                    collection = collection.where(fieldPath, "<=", parseInt(ratingEnd))
                }
                //collection = collection.orderBy("coins").limit(1)
                this.getCollection(collection)
            },
            submitTimestamp(start, end, fieldPath){
                let collection = database.collection("users")
                if( start ){
                    collection = collection.where(fieldPath, ">=", firebase.firestore.Timestamp.fromDate(new Date(start)))
                }
                if( end ) {
                    collection = collection.where(fieldPath, "<=", firebase.firestore.Timestamp.fromDate(new Date(end)))
                }
                //collection = collection.orderBy("coins").limit(1)
                //firebase.firestore.Timestamp.fromDate(new Date("December 10, 1815"))
                this.getCollection(collection)
            },
            getCollection(collection){
                //database
                //    .collection("users")
                //.where("platform", "==", "Android")
                //.where("payer", "==", true)
                //.where("payer", "==", false)
                //.where("payer", ">", true)
                //.where("name", "==", "test2")
                //.orderBy("created")
                collection.get()
                    .then((querySnapshot) => {
                        this.setItems(querySnapshot);
                        this.$vuetify.goTo(this.pageHeight)
                    }).catch((error) => {
                    console.log(error)
                });  //store.getters["database/getProducts"];
            },
            setItems(querySnapshot){
                this.items = []
                querySnapshot.forEach((doc) => {
                    //console.log(`${doc.id} => ${ Object.values(doc.data())}`);
                    this.setItem(doc)
                });
            },
            setItem(doc){
                //console.log(`${doc.id} => ${ Object.values(doc.data())}`);
                let data = doc.data()
                this.items.push({
                    id: doc.id,
                    name: data.name,
                    payer: data.payer,
                    platform: data.platform,
                    version: data.version,
                    bomb1: data.bomb1,
                    bomb2: data.bomb2,
                    bomb3: data.bomb3,
                    bomb4: data.bomb4,
                    bomb6: data.bomb6,
                    bomb7: data.bomb7,
                    coins: data.coins,
                    energy: data.energy,
                    season: data.season,
                    level: data.level,
                    created: data.created ? dayJS(data.created.toDate()).fromNow() : '', // this.formatDate(data.created.toDate().toISOString().substr(0, 10))
                    updated: data.updated ? dayJS(data.updated.toDate()).fromNow() : '', // this.formatDate(data.updated.toDate().toISOString().substr(0, 10))
                })
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
        },
        created() {
            //this.items = []// StoreHelper.getProducts()
        }
    };
</script>
